var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetpointOptimization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2118_11248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.91117 8.00778L7.15381 12.2504M7.15381 12.2504L2.91117 16.4931M7.15381 12.2504L1 12.2504M20.5888 16.4931L16.3462 12.2504M16.3462 12.2504L20.5888 8.00778M16.3462 12.2504L23 12.2504",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9926 3.41116L11.75 7.6538M11.75 7.6538L7.50737 3.41116M11.75 7.6538L11.75 1M7.50737 21.0888L11.75 16.8462M11.75 16.8462L15.9926 21.0888M11.75 16.8462L11.75 23",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7626,
    cy: 12.2502,
    r: 1.75892,
    transform: "rotate(45 11.7626 12.2502)",
    fill: "#F7F9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2118_11248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetpointOptimization);
export default __webpack_public_path__ + "static/media/setpoint-optimization.d8e7bd367741d34f84cdd4a21a74478a.svg";
export { ForwardRef as ReactComponent };